// extracted by mini-css-extract-plugin
module.exports = {"blog":"BlogBase_blog__tyvQS","container":"BlogBase_container__czh7B"};